module.exports = __webpack_public_path__ + "static/fundwall_3-f96b8443c9a2fdc33d428ced9b2544a0.jpg";